import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";

const DESERT = "https://images.unsplash.com/photo-1543604502-9baac28067ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxkZXNlcnQlMjBzYW5kJTIwdGV4dHVyZSUyMG5ldXRyYWx8ZW58MHx8fHwxNzg2Mzk1MDQyfDA&ixlib=rb-4.1.0&q=85";

const pillars = {
  en: ["Independent Perfumery", "Small-batch Production", "Personal Formulation", "Raw-material Exploration", "Limited Releases", "Abu Dhabi Origin"],
  ar: ["عطور مستقلة", "إنتاج بكميات صغيرة", "تركيب شخصي", "استكشاف المواد الخام", "إصدارات محدودة", "من أبوظبي"],
};

export default function Story() {
  const { t, lang } = useLang();
  const [content, setContent] = useState({});
  useEffect(() => { api.get("/content").then((r) => setContent(r.data)).catch(() => {}); }, []);
  const storyTitle = content[`story_title_${lang}`] || "";
  const paragraphs = (content[`story_${lang}`] || "").split(/\n\n+/).map((p) => p.trim()).filter(Boolean);
  const closeLines = (content[`story_close_${lang}`] || "").split("\n").map((l) => l.trim()).filter(Boolean);

  return (
    <div>
      <section className="relative h-[60vh] min-h-[420px] flex items-end">
        <div className="absolute inset-0">
          <img src={DESERT} alt="Abu Dhabi" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0A08] via-[#0B0A08]/50 to-transparent" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 pb-16 w-full">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C49A6C] mb-4">{t("location")}</p>
          <h1 className="serif text-5xl md:text-7xl leading-tight">{t("nav_story")}</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 md:px-10 py-20 md:py-28" data-testid="story-body">
        {storyTitle && (
          <motion.h2 initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
            className="serif italic text-3xl md:text-5xl text-[#C49A6C] leading-tight mb-12">
            {storyTitle}
          </motion.h2>
        )}
        <div className="space-y-7">
          {paragraphs.map((p, i) => (
            <motion.p key={p} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: Math.min(i * 0.04, 0.3) }}
              className="text-[#C9C0B4] text-base md:text-[17px] leading-[1.95]">
              {p}
            </motion.p>
          ))}
        </div>

        {closeLines.length > 0 && (
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
            className="mt-16 pt-10 border-t border-[#262421] space-y-2">
            {closeLines.map((l, i) => (
              <p key={l} className="serif text-2xl md:text-3xl text-[#F2EBE1] leading-snug">{l}</p>
            ))}
          </motion.div>
        )}
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-10 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-[#262421] border border-[#262421]">
          {pillars[lang].map((p, i) => (
            <div key={p} className="bg-[#0B0A08] p-8 md:p-12 flex items-center min-h-[140px]">
              <div>
                <span className="serif text-3xl text-[#C49A6C]/40">0{i + 1}</span>
                <p className="text-sm md:text-base mt-3 text-[#F2EBE1]">{p}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
